var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.46,
    height: 15.46,
    viewBox: "0 0 15.46 15.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H18.762V2.1H0Z",
    transform: "translate(2.463 0) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.044.339H18.806v2.1H.044Z",
    transform: "translate(0 13.766) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.2da26b3631e29d8feb2c89b6cd0e5144.svg";
export { ForwardRef as ReactComponent };